export function contentPublicBaseUrl(): string {
  return import.meta.env.VITE_XQ_CONTENT_BASE_URL || "/public";
}

export function contentBaseUrl(): string {
  return `${contentPublicBaseUrl()}/json`;
}

export function contentSoundsBaseUrl(): string {
  return `${contentPublicBaseUrl()}/sounds`;
}

export function contentImagesBaseUrl(): string {
  return `${contentPublicBaseUrl()}/images`;
}

export function getExerciseImageUrl(file: string): string {
  const path = String(file ?? "").trim().replace(/\.webp$/i, "");
  if (!path) {
    return "";
  }
  return `${contentImagesBaseUrl()}/${path}.webp`;
}
